export const getMuiBackdrop = (paletteVars): Record<string, unknown> => ({
  MuiBackdrop: {
    styleOverrides: {
      root: {
        backgroundColor: paletteVars.transparent.light[800],
      },
      invisible: {
        backgroundColor: 'transparent',
      },
    },
  },
});
